<template>
  <table class="l-form-table" style="width:100%;">
    <caption>ソリューション</caption>
    <tr>
      <td>
        <template v-for="solution in solutionList">
          <label :key="solution.solutionId" style="margin: 5px;">
            <CheckBoxForSelect class="inline"
              :value="solution.solutionId"
              :checked="solution.solutionDiagItemId ? solution.solutionId : null"
              @check-input="checkSolutionId"
              style="display: inline;"
            />
            {{ solution.solutionName }}
          </label>
       </template>
      </td>
    </tr>
  </table>
</template>

<script>
import CheckBoxForSelect from '@/components/parts/form/CheckBoxForSelect.vue';

export default {
  components: {
    CheckBoxForSelect,
  },
  props: {
    solutionList: []
  },
  methods: {
    checkSolutionId(params) {
      this.$emit("check-solution-id", params);
    }
  }
}
</script>
